<template>
  <div class="pageContainer">
    <div class="container-1350 course-video">
      <div class="sidebar">
        <h2>{{ selectedCourse.name }}</h2>
        <img :src="selectedCourse.author.image" />
        <p class="name">{{ selectedCourse.author.name }}</p>
        <p class="sub">{{ selectedCourse.author.designation }}</p>
        <ubtn class="get-certificate" v-if="allowCertificateGeneration"
          >Get Certificate</ubtn
        >
        <ul>
          <li
            class="video-link"
            :key="index"
            @click="selectVideo(item)"
            v-bind:class="{
              watched: item.watched,
              active: item.active
            }"
            v-for="(item, index) in selectedCourse.videos"
          >
            <span class="lesson">Lesson {{ index + 1 }}</span>
            <span class="title">{{ item.name }}</span>
          </li>
        </ul>
      </div>
      <div class="content">
        <div class="playing">
          <youtube
            :video-id="selectedVideo.link"
            :player-vars="playerVars"
            fit-parent
            ref="upskillplayer"
            @ended="videoEnded"
            v-if="selectedVideo.link"
          ></youtube>
          <div
            style="width: 100%; height: 480px; display: flex; align-content: center; justify-content: center; flex-direction: column;"
            v-if="!selectedVideo.link"
          >
            <h3>{{ selectedCourse.description }}</h3>
            <h5 class="text-md-center" style="color: royalblue">
              (Please select a lesson from the sidebar)
            </h5>
          </div>
        </div>
        <p class="sub">{{ selectedCourse.categories }}</p>
        <div class="title-container">
          <div class="title">{{ selectedVideo.name }}</div>
          <ul>
            <li>
              <a href="#">
                <img src="../../assets/images/awesome-linkedin.svg" />
              </a>
            </li>
            <li>
              <a href="#">
                <img src="../../assets/images/ionic-logo-facebook.svg" />
              </a>
            </li>
          </ul>
        </div>
        <div class="courses-carousel">
          <h3>
            <span>More popular Courses</span>
            <div class="carousel-nav">
              <a class="prev" href="#" data-target="#popular-courses:prev"></a>
              <a class="next" href="#" data-target="#popular-courses:next"></a>
            </div>
          </h3>
          <div id="popular-courses" class="cb-carousel">
            <div class="cb-carousel-item-container x4">
              <div
                class="item"
                v-for="course in popular"
                :key="course.id"
                @click="GotoBlogByID(course.id)"
              >
                <div class="course">
                  <div class="thumb">
                    <img :src="course.image" alt />
                  </div>
                  <h4>{{ course.name }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      playerVars: {
        autoplay: 1
      },
      other: {},
      selectedCourse: { author: {} },
      selectedVideo: {},
      activeIndex: 0,
      interval: {},
      courses: [],
      allowCertificateGeneration: false,
      popular: []
    };
  },
  methods: {
    videoEnded() {
      this.selectedVideo.watched = true;
      this.canGenerateCertificate();
      this.$mix.updateCourse(this.selectedCourse, this.courses, this.other);
      this.next();
    },
    canGenerateCertificate() {
      let noOfWatches = this.selectedCourse.videos
        .map(o => (o.watched ? 1 : 0))
        .reduce((x, y) => x + y);
      if (noOfWatches === this.selectedCourse.videos.length) {
        this.allowCertificateGeneration = true;
      }
    },
    selectVideo(item) {
      this.selectedCourse.videos.forEach(c => {
        c.active = false;
      });
      item.active = true;
      this.selectedVideo = item;
    },
    next() {
      let indexOfSelectedVideo = this.selectedCourse.videos.indexOf(
        this.selectedVideo
      );
      if (indexOfSelectedVideo < this.selectedCourse.videos.length - 1) {
        this.selectVideo(this.selectedCourse.videos[indexOfSelectedVideo + 1]);
      } else {
        if (this.allowCertificateGeneration) {
          this.SuccessAlert("You have successfully completed this course! ");
        } else {
          this.selectVideo(this.selectedCourse.videos[0]);
        }
      }
    }
  },
  created() {
    window.fbq('track', 'ViewContent');
    let param = this.$route.params.id;
    this.$mix.getCourse(param).then(res => {
      this.selectedCourse = res.course;
      this.popular = res.popular;
      this.courses = res.courses;
      this.Loaded();
    });
  }
};
</script>

<style scoped>
.video-link:hover {
  cursor: pointer;
  background-color: rgba(20, 255, 131, 0.25);
}
</style>
